import * as z from "zod";
import { TranslatedText } from "./TranslatedText";
export const Markdown = z.object({
    type: z.literal("markdown"),
    value: z.object({
        text: TranslatedText,
    }),
});
